import { Outlet } from 'react-router-dom';
import { AdminSidebar } from '@/components/admin/AdminSidebar';
import { MobileTabBar, type MobileTabItem } from '@/components/MobileTabBar';
import {
  LayoutDashboard,
  Users,
  FileText,
  Shield,
  BarChart3,
} from 'lucide-react';

const adminNavItems: MobileTabItem[] = [
  {
    label: 'Dashboard',
    href: '/admin/dashboard',
    icon: LayoutDashboard,
  },
  {
    label: 'Analytics',
    href: '/admin/analytics',
    icon: BarChart3,
  },
  {
    label: 'Posts',
    href: '/admin/posts',
    icon: FileText,
  },
  {
    label: 'Users',
    href: '/admin/users',
    icon: Users,
  },
  {
    label: 'Audit',
    href: '/admin/audit-logs',
    icon: Shield,
  },
];

export function AdminLayout() {
  return (
    <div className="flex min-h-screen bg-background">
      {/* Desktop sidebar - hidden on mobile */}
      <div className="hidden lg:block">
        <AdminSidebar />
      </div>

      {/* Main content with bottom padding for mobile tab bar */}
      <main className="flex-1 overflow-hidden pb-16 lg:pb-0">
        <Outlet />
      </main>

      {/* Mobile bottom tab bar */}
      <MobileTabBar items={adminNavItems} />
    </div>
  );
}
